import { useParams } from "react-router-dom";
import { Container, Input, Back, Loading } from "../../components";
import { fileUrl, handleClick, useFETCH, usePOST } from "../../APIs/useMyAPI";
import AddImages from "../../components/AddImage/AddImages";
import { useEffect } from "react";

function AddExhibition() {
  const { id } = useParams();
  const {
    formData,
    handleChange,
    loading,
    error,
    handleSubmit,
    setFormData,
    img,
    setImg,
  } = usePOST({});
  const handleFormSubmit = (event) => {
    event.preventDefault();
    handleSubmit(isNaN(id) ? "exhibitions" : `exhibitions/${id}`);
  };
  const { data } = useFETCH(`exhibitions/${id}`);
  let dataUp = data?.data.data;
  useEffect(() => {
    !isNaN(id) &&
    setFormData({
      name: dataUp?.name,
      type: dataUp?.type,
      price: dataUp?.price,
      description: dataUp?.description,
    });
  }, [dataUp]);
  return (
    <Container>
      {loading ? <Loading /> : ""}
      <div className="flex flex-col mb-32  ">
        <div className="w-[50%] max-sm:w-[80%] mx-auto mt-8 space-y-5">
          <Input
            title="Add Exhibitions Name"
            onChange={handleChange}
            name="name"
            value={formData.name}
          />
          <Input
            title="Add Exhibitions Type"
            onChange={handleChange}
            name="type"
            value={formData.type}
          />
          <Input
            title="Add Exhibitions Price"
            onChange={handleChange}
            name="price"
            value={formData.price}
          />
          <textarea
            type="text"
            onChange={handleChange}
            value={formData.description}
            name="description"
            className="text-Gray font-semibold px-2 outline-none border-2 border-Brown rounded-xl h-[150px] w-[100%]"
            placeholder="Add Exhibitions Description"
          />
        </div>
        <div className="mt-8">
          <AddImages
            onChange={handleChange}
            name="image"
            image={"Add Photo"}
          ></AddImages>
        </div>
        <div className="flex justify-center space-x-3 mt-6">
          {img && (
            <div className="relative">
              <div
                onClick={() => {
                  setImg("");
                  setFormData("");
                }}
                className="bg-red-600 text-white w-5 h-5 rounded-full absolute -top-2 -left-1 z-10 flex cursor-pointer items-center justify-center "
              >
                X
              </div>
              <img
                onClick={handleClick}
                className="w-[300px] h-[220px] mx-auto rounded-2xl mb-6"
                src={img}
                alt=""
              />
            </div>
          )}
          {isNaN(id) ? (
            ""
          ) : (
            <div className="relative">
              <img
                onClick={handleClick}
                className="w-[300px] h-[220px] mx-auto rounded-2xl mb-6"
                src={fileUrl + dataUp?.image}
                alt=""
              />
            </div>
          )}
        </div>
      </div>
      <div className="text-red-500 font-semibold ">{error}</div>
      <Back onClick={handleFormSubmit}>Save</Back>
    </Container>
  );
}
export default AddExhibition;
